'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createReducer2 = require('./utils/createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  show: false,
  title: ''
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.SHOW, function (state, _ref) {
  var payload = _ref.payload;
  return _extends({
    show: true
  }, payload);
}), _defineProperty(_createReducer, _actions.CLOSE, function () {
  return initialState;
}), _createReducer));


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-sweetalert/lib/reducer.js
// module id = ./node_modules/react-redux-sweetalert/lib/reducer.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons